<template lang="pug">
    .z-select-item(v-on:click="select" data-isitem="true") {{$props.label}}
</template>
<script>
    export default {
        name: 'z-select-item',
        components: {},
        props: {
            value: {
                type: [String, Number, Boolean],
                default: () => ''
            },
            label: {
                type: [String, Number, Boolean],
                default: () => ''
            }    
        },
        data() {
            return {
            }
        },
        created() {},
        watch: {},
        computed: {},
        methods: {
            select(e) {
                if (this.$parent) this.$parent.select(this.$props.label, this.$props.value);
                this.$emit('click', e);
            }
        }
    }
</script>
<style lang="sass">
    .z-select-item
        cursor: pointer
        width: 100%
        padding: 4px 10px
        font-size: 14px
        line-height: 16px
        &:hover, &.active
            background: #BEBEBE
</style>


// WEBPACK FOOTER //
// ZSelectItem.vue?1bcca23c